import http from 'hub-http/clients/apiClient';
export default class CrmSearchAPI {
  static search(data) {
    return http.post('/crm-search/search', {
      data
    });
  }
}